module.exports = __webpack_public_path__ + "assets/targetIcon-e663f3.svg";